"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SourgumCustomerSchema = void 0;
const transport_types_1 = require("@alliance-disposal/transport-types");
const meta_data_1 = require("../base/meta-data");
exports.SourgumCustomerSchema = {
    name: 'sourgum-customer',
    alias: 'Sourgum Customer',
    shortName: 'Customer',
    applications: ['aap'],
    returnType: {
        aap: transport_types_1.Customer.AllianceCustomerTransport,
    },
    searchableAttributes: [
        {
            field: 'contacts.firstName',
            alias: 'Contact Name',
            shortName: 'Name',
            searchableByDefault: true,
            isArrayOfObjects: true,
        },
        {
            field: 'contacts.lastName',
            alias: 'Contact Name',
            shortName: 'Name',
            searchableByDefault: true,
            isArrayOfObjects: true,
        },
        {
            field: 'contacts.email',
            alias: 'Contact Email',
            shortName: 'Email',
            searchableByDefault: true,
            isArrayOfObjects: true,
        },
        {
            field: 'contacts.phoneNumber',
            alias: 'Contact Phone',
            shortName: 'Phone',
            searchableByDefault: false,
            isArrayOfObjects: true,
        },
        {
            field: 'companyName',
            alias: 'Company Name',
            shortName: 'Company',
            searchableByDefault: true,
        },
        {
            field: 'customerNumber',
            alias: 'Account Number',
            shortName: 'account_number',
            searchableByDefault: false,
        },
        {
            field: 'billingAddress.addressLine1',
            alias: 'Billing Address Line 1',
            shortName: 'Address',
            searchableByDefault: true,
        },
        {
            field: 'billingAddress.addressLine2',
            alias: 'Billing Address Line 2',
            shortName: 'Address Line 2',
            searchableByDefault: true,
        },
        {
            field: 'billingAddress.city',
            alias: 'Billing Address City',
            shortName: 'City',
            searchableByDefault: true,
        },
        {
            field: 'billingAddress.state',
            alias: 'Billing Address State',
            shortName: 'State',
            searchableByDefault: true,
        },
        {
            field: 'billingAddress.zip',
            alias: 'Billing Address Zip Code',
            shortName: 'Zip',
            searchableByDefault: false,
        },
    ],
    filterableAttributes: [
        {
            field: 'type',
            alias: 'Customer Type',
            shortName: 'Type',
            type: 'STRING',
            allowedOperators: 'ALL',
            options: transport_types_1.Customer.customerTypes.map((type) => ({
                value: type,
                label: transport_types_1.Customer.CustomerTypeLabels[type],
            })),
            allowsMultipleValues: true,
        },
        {
            type: 'BOOLEAN',
            field: 'taxExempt',
            alias: 'Tax Exempt',
            shortName: 'Tax Exempt',
            allowedOperators: ['IS_EQUAL_TO'],
        },
        {
            type: 'BOOLEAN',
            field: 'chargeFullPrice',
            alias: 'Charge Full Price',
            shortName: 'Charge Full Price',
            allowedOperators: ['IS_EQUAL_TO'],
        },
        ...meta_data_1.MetaDataFilters,
    ],
};
//# sourceMappingURL=sourgum-customer.js.map